import { Messages } from "../types";

export const ru: Messages = {
  /* Verbs and nouns shared by every screen ------------------------------ */
  "common.add": "Добавить",
  "common.assign": "Назначить",
  "common.back": "Назад",
  "common.cancel": "Отмена",
  "common.clear": "Снять выбор",
  "common.confirm": "Подтвердить",
  "common.continue": "Продолжить",
  "common.delete": "Удалить",
  "common.menu": "Меню",
  "common.open": "Открыть",
  "common.refresh": "Обновить",
  "common.remove": "Исключить",
  "common.retry": "Повторить",
  "common.save": "Сохранить",
  "common.search": "Поиск",
  "common.signIn": "Войти",
  "common.signOut": "Выйти",

  /* Navigation ---------------------------------------------------------- */
  "nav.group.clinic": "Клиника",
  "nav.doctors": "Врачи",
  "nav.caretakers": "Сиделки",
  "nav.patients": "Пациенты",
  "nav.role": "Администратор организации",
  "sidebar.collapse": "Свернуть меню",
  "sidebar.expand": "Развернуть меню",

  /* Language switcher --------------------------------------------------- */
  "language.label": "Язык",

  /* Turned-away session ------------------------------------------------- */
  "access.denied.title": "Доступ запрещён",
  "access.denied.subtitle":
    "Эта консоль предназначена для администраторов организации. Войдите с учётной записью администратора организации.",

  /* Command palette ----------------------------------------------------- */
  "palette.placeholder": "Перейти к разделу…",
  "palette.aria": "Перейти к разделу",
  "palette.empty": "Ничего не найдено",
  "palette.section.sections": "Разделы",
  "palette.section.actions": "Действия",
  "palette.foot.move": "для перехода",
  "palette.foot.open": "чтобы открыть",

  /* Action bar ---------------------------------------------------------- */
  "crud.selected": "Выбрано:",
  "crud.hint.default": "Выберите строку, чтобы открыть её",
  "crud.hint.assignPeople": "Отметьте, кого нужно назначить",
  "crud.hint.removePatients": "Отметьте пациентов, чтобы убрать их из списка",
  "crud.hint.removeCaretakers": "Отметьте сиделок, чтобы убрать их из списка",

  /* Table columns ------------------------------------------------------- */
  "person.column.firstName": "Имя",
  "person.column.lastName": "Фамилия",
  "person.column.phone": "Телефон",
  "person.column.email": "Эл. почта",

  /* Form labels --------------------------------------------------------- */
  "person.field.firstName": "Имя:",
  "person.field.lastName": "Фамилия:",
  "person.field.phone": "Номер телефона:",
  "person.field.email": "Эл. почта:",
  "person.field.password": "Пароль:",
  "person.field.gender": "Пол:",
  "person.field.birthday": "Дата рождения:",
  "person.field.country": "Страна:",
  "person.field.address": "Адрес:",
  "person.field.address2": "Адрес, строка 2:",
  "person.field.city": "Город:",
  "person.field.state": "Область:",
  "person.field.postcode": "Индекс:",
  "person.field.allowedDistance": "Допустимое расстояние:",
  "person.field.checkAllowedDistance": "Проверять расстояние:",
  "person.field.doctorFirstName": "Имя врача:",
  "person.field.doctorLastName": "Фамилия врача:",
  "person.field.doctorPhone": "Телефон врача:",
  "person.field.diagnosis": "Диагноз:",

  /* Field examples ------------------------------------------------------ */
  "person.placeholder.firstName": "Иван",
  "person.placeholder.lastName": "Иванов",
  "person.placeholder.phone": "1 (344) 333-3333",
  "person.placeholder.email": "john.doe@email.com",
  "person.placeholder.password": "пароль",
  "person.placeholder.country": "Начните вводить название",
  "person.placeholder.address": "ул. Садовая, 27",
  "person.placeholder.address2": "Слева",
  "person.placeholder.city": "Москва",
  "person.placeholder.state": "Московская обл.",
  "person.placeholder.postcode": "101000",
  "person.placeholder.doctorFirstName": "Михаил",
  "person.placeholder.doctorLastName": "Сантос",
  "person.placeholder.doctorPhone": "+1 456 565-3443",
  "person.placeholder.diagnosis": "Диагноз",

  /* Field validation ---------------------------------------------------- */
  "person.rule.firstName": "пожалуйста, введите имя",
  "person.rule.phone": "пожалуйста, введите номер телефона",
  "person.rule.email": "пожалуйста, введите корректный адрес эл. почты",
  "person.rule.code": "пожалуйста, введите код",

  /* Enumerated values --------------------------------------------------- */
  "person.gender.male": "Мужской",
  "person.gender.female": "Женский",
  "person.gender.other": "Другой",

  "patient.hint.allowedDistance": "Расстояние от дома в метрах, после которого поднимается тревога.",

  /* Search fields ------------------------------------------------------- */
  "list.search.person": "Поиск по имени, телефону или эл. почте",
  "list.search.people": "Поиск людей",
  "list.search.patients": "Поиск пациентов",
  "list.search.caretakers": "Поиск опекунов",

  /* Empty lists --------------------------------------------------------- */
  "empty.default.title": "Здесь пока ничего нет",
  "empty.default.hint": "Добавленные записи появятся в этом списке.",
  "empty.assign.title": "Назначать больше некого",
  "empty.assign.hint": "Все доступные люди уже в этом списке.",
  "empty.patients.title": "Пациенты не назначены",
  "empty.patients.hint": "Назначьте пациентов, и они появятся здесь.",
  "empty.caretakers.title": "Сиделки не назначены",
  "empty.caretakers.hint": "Назначьте опекунов, и они появятся здесь.",

  /* Record tabs --------------------------------------------------------- */
  "tabs.doctor": "Врач",
  "tabs.caretaker": "Сиделка",
  "tabs.patients": "Пациенты",
  "tabs.caretakers": "Опекуны",

  /* Records ------------------------------------------------------------- */
  "doctor.new": "Новый врач",
  "doctor.one": "Врач",
  "caretaker.new": "Новый опекун",
  "caretaker.one": "Сиделка",
  "patient.new": "Новый пациент",
  "patient.one": "Пациент",

  /* Assignment ---------------------------------------------------------- */
  "assign.eyebrow": "Назначение",
  "assign.people.title": "Назначить людей",
  "assign.caretakers.title": "Назначить сиделок",
  "assign.patients.title": "Назначить пациентов",
  "assign.caretakers.forDoctor": "Сиделки, ещё не назначенные этому врачу.",
  "assign.patients.forDoctor": "Пациенты, ещё не назначенные этому врачу.",
  "assign.patients.forCaretaker": "Пациенты, ещё не назначенные этому опекуну.",
  "assign.selection.count": {
    one: "{count} человек",
    few: "{count} человека",
    many: "{count} человек",
    other: "{count} человека"
  },

  /* Confirmations ------------------------------------------------------- */
  "confirm.remove.title": "Исключить из клиники?",
  "confirm.remove.doctor":
    "Исключить врача «{name}» из клиники? Учётная запись сохранится, но доступ к этой организации будет закрыт.",
  "confirm.remove.caretaker":
    "Исключить сиделку «{name}» из клиники? Учётная запись сохранится, но доступ к этой организации будет закрыт.",
  "confirm.remove.patient":
    "Исключить пациента «{name}» из клиники? Учётная запись сохранится, но доступ к этой организации будет закрыт.",
  "confirm.delete.title": "Удалить безвозвратно?",
  "confirm.delete.doctor":
    "Полностью удалить врача «{name}»? Это действие нельзя отменить.",
  "confirm.delete.caretaker":
    "Полностью удалить опекуна «{name}»? Это действие нельзя отменить.",
  "confirm.delete.patient":
    "Полностью удалить пациента «{name}»? Это действие нельзя отменить.",

  /* Failures ------------------------------------------------------------ */
  "auth.failed.title": "Ошибка аутентификации",
  "auth.failed.body": "Сессия больше не действительна, пожалуйста, войдите снова.",
  "error.server": "Ошибка сервера",

  /* Account ------------------------------------------------------------- */
  "account.title": "Аккаунт",
  "account.email": "Эл. почта",
  "account.notAuthenticated": "Вы не аутентифицированы",

  /* Adding a patient ---------------------------------------------------- */
  "addPatient.eyebrow": "Добавление пациента",
  "addPatient.pageTitle": "Добавить пациента",
  "addPatient.phone.title": "Номер телефона",
  "addPatient.phone.hint":
    "Мы отправим на этот номер одноразовый код, чтобы подтвердить, что он принадлежит пациенту.",
  "addPatient.phone.label": "Номер телефона",
  "addPatient.phone.help": "Укажите код страны.",
  "addPatient.sendCode": "Отправить код",
  "addPatient.cannotAdd.title": "Не удалось добавить пациента",
  "addPatient.exists.own": "Этот пациент уже есть в нашей клинике.",
  "addPatient.exists.other": "Этот пациент уже есть в другой клинике.",
  "addPatient.code.title": "Код активации",
  "addPatient.code.hint":
    "Введите восьмизначный код, показанный в приложении пациента.",
  "addPatient.code.label": "Код",
  "addPatient.code.placeholder": "XXXX-XXXX",
  "addPatient.confirm.title": "Подтвердите номер",
  "addPatient.confirm.hint":
    "Мы отправили шестизначный код по SMS. Введите его, чтобы подтвердить, что номер принадлежит пациенту.",
  "addPatient.confirm.pageTitle": "Подтверждение номера телефона",
  "addPatient.otp.label": "Код",
  "addPatient.otp.help": "Шесть цифр.",
  "addPatient.otp.placeholder": "xxx-xxx",
  "addPatient.resend": "Отправить снова",
  "addPatient.resendPrompt": "Сообщение не пришло? Повторно через",
  "addPatient.resendSeconds": "{seconds} с",

  /* Reference screen ---------------------------------------------------- */
  "countries.eyebrow": "Справочник",
  "countries.title": "Страны",
  "countries.subtitle":
    "Служебная страница: список стран, который использует форматирование телефонных номеров."
};
